"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacetedDocumentBase = exports.FacetedSearchApi = exports.FacetSortOptionsEnum = exports.DepthOffsetEnum = exports.FilterItemTypesEnum = void 0;
var tslib_1 = require("tslib");
var json2typescript_1 = require("json2typescript");
var FilterTypings_1 = require("../../../Views/Partials/Components/Filters/FilterTypings");
var Search_global_1 = require("../Search.global");
var Search_utils_1 = require("../Search.utils");
var SearchBaseApi_1 = require("../SearchBaseApi");
var FilterItemTypesEnum;
(function (FilterItemTypesEnum) {
    FilterItemTypesEnum["ProductCategory"] = "productCategory";
    FilterItemTypesEnum["ProductSubCategory"] = "productSubCategory";
    FilterItemTypesEnum["Product"] = "product";
    FilterItemTypesEnum["ProductExternalContent"] = "productExternalContent";
    FilterItemTypesEnum["ProductReference"] = "productReference";
    FilterItemTypesEnum["NewsPage"] = "newsPage";
    FilterItemTypesEnum["CaseStudyPage"] = "caseStudyPage";
    FilterItemTypesEnum["DownloadPage"] = "downloadPage";
    FilterItemTypesEnum["EventPage"] = "eventPage";
    FilterItemTypesEnum["EventExternalContent"] = "eventExternalContent";
})(FilterItemTypesEnum = exports.FilterItemTypesEnum || (exports.FilterItemTypesEnum = {}));
var DepthOffsetEnum;
(function (DepthOffsetEnum) {
    DepthOffsetEnum[DepthOffsetEnum["ProductCategory"] = 2] = "ProductCategory";
    DepthOffsetEnum[DepthOffsetEnum["CategoriesAndSubCategory"] = 1] = "CategoriesAndSubCategory";
    DepthOffsetEnum[DepthOffsetEnum["DownloadPage"] = 2] = "DownloadPage";
    DepthOffsetEnum[DepthOffsetEnum["ApplicationsAndSolutions"] = 2] = "ApplicationsAndSolutions";
})(DepthOffsetEnum = exports.DepthOffsetEnum || (exports.DepthOffsetEnum = {}));
var FacetSortOptionsEnum;
(function (FacetSortOptionsEnum) {
    FacetSortOptionsEnum["AscendingSortByStartDate"] = "startDate_asc";
    FacetSortOptionsEnum["DescendingSortByStartDate"] = "startDate_desc";
    FacetSortOptionsEnum["AscendingSortByEndDate"] = "endDate_asc";
    FacetSortOptionsEnum["AscendingSortByTitle"] = "title_asc";
})(FacetSortOptionsEnum = exports.FacetSortOptionsEnum || (exports.FacetSortOptionsEnum = {}));
var FacetedSearchApi = /** @class */ (function (_super) {
    tslib_1.__extends(FacetedSearchApi, _super);
    function FacetedSearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FacetedSearchApi.prototype.buildQuery = function (params) {
        var builder = new Search_utils_1.SearchParamsBuilder();
        builder.Append('q', params.query || '*');
        builder.Append('locale', params.locale);
        builder.AppendArray('type', params.itemTypes);
        if (params.filters) {
            params.filters.forEach(function (filterItem) {
                var _a = filterItem.split('='), name = _a[0], value = _a[1];
                builder.Append("" + SearchBaseApi_1.FACET_PREFIX + name, value);
            });
        }
        builder.Append('hits', params.pageSize);
        builder.Append('offset', params.offset);
        builder.Append('path', params.path, function (value) {
            return value.slice(0, -1);
        });
        builder.Append('pathExclude', params.pathExclude, function (value) {
            return value[value.length - 1] === '/' ? value : value + '/';
        });
        if (!!params.sort && params.sort !== FilterTypings_1.FilterSortOptions.Default) {
            builder.Append('sort', params.sort);
        }
        builder.Append('globalDepth', params.globalDepth);
        builder.Append('startDateTo', params.startDateTo);
        builder.Append('startDateFrom', params.startDateFrom);
        builder.Append('endDateTo', params.endDateTo);
        builder.Append('endDateFrom', params.endDateFrom);
        builder.Append('lang', params.language);
        return builder.toString();
    };
    return FacetedSearchApi;
}(SearchBaseApi_1.SearchBaseApi));
exports.FacetedSearchApi = FacetedSearchApi;
/* tslint:disable */
var FacetedDocumentBase = /** @class */ (function (_super) {
    tslib_1.__extends(FacetedDocumentBase, _super);
    function FacetedDocumentBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.country = undefined;
        _this.description = undefined;
        _this.globalDepth = undefined;
        _this.image = undefined;
        _this.imageAltText = undefined;
        _this.locale = undefined;
        _this.path = undefined;
        _this.segments = undefined;
        _this.title = undefined;
        _this.type = undefined;
        _this.url = undefined;
        return _this;
    }
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('country', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], FacetedDocumentBase.prototype, "country", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('description', String),
        tslib_1.__metadata("design:type", String)
    ], FacetedDocumentBase.prototype, "description", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('globalDepth', Number),
        tslib_1.__metadata("design:type", Number)
    ], FacetedDocumentBase.prototype, "globalDepth", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('image', String),
        tslib_1.__metadata("design:type", String)
    ], FacetedDocumentBase.prototype, "image", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('imageAltText', String),
        tslib_1.__metadata("design:type", String)
    ], FacetedDocumentBase.prototype, "imageAltText", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('locale', String),
        tslib_1.__metadata("design:type", String)
    ], FacetedDocumentBase.prototype, "locale", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('path', String),
        tslib_1.__metadata("design:type", String)
    ], FacetedDocumentBase.prototype, "path", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('segments', [String], true),
        tslib_1.__metadata("design:type", Array)
    ], FacetedDocumentBase.prototype, "segments", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('title', String),
        tslib_1.__metadata("design:type", String)
    ], FacetedDocumentBase.prototype, "title", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('type', String),
        tslib_1.__metadata("design:type", String)
    ], FacetedDocumentBase.prototype, "type", void 0);
    tslib_1.__decorate([
        json2typescript_1.JsonProperty('url', String),
        tslib_1.__metadata("design:type", String)
    ], FacetedDocumentBase.prototype, "url", void 0);
    FacetedDocumentBase = tslib_1.__decorate([
        json2typescript_1.JsonObject('FacetedDocumentBase')
    ], FacetedDocumentBase);
    return FacetedDocumentBase;
}(Search_global_1.DocumentBase));
exports.FacetedDocumentBase = FacetedDocumentBase;
/* tslint:enable */
